import RegisterOnlineId from './RegisterOnlineIdContainer';

export default RegisterOnlineId;